<template>
  <div class="container">
   <div class="content">
    <div class="content_left">
      <div ref="textContainer"  class="content_left_top">
        <img :src="this.companyDetail.avatar" style="padding: 16px;"  width="160px" height="100px" >
        <div class="center_top">
          <h2 style="padding: 16px 0 8px 0; height: 28px;font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: 700;font-size: 20px;"
            >{{ this.companyDetail.name }}</h2>  <span style="position: absolute;margin-top: 12px; margin-left: 310px;">
              <div class="button-container">
               <button onclick="window.history.back()"   style="position: absolute; width: 100px;margin-left: 100px; height: 36px;">返回</button>
    <button 
    @click="gopartner()" 
      class="gsap-button"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"  
      ref="button"
    >
     合作咨询
    </button>
  </div>
            </span>
            <!-- <p style="font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: 400;
            font-size: 12px;color: #7E7F83;line-height: 17px;
            text-align: justify;padding: 0 16px 0 0;"
            >
            {{ this.companyDetail.introduction }}</p> -->
            <p ref="textContent" style="font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
              font-weight: 400;
              font-size: 12px;color: #7E7F83;line-height: 17px;
              text-align: justify;padding: 0 16px 0 0;">
      {{ isExpanded ? companyDetail.introduction : truncatedText }}
    </p>
    <button v-if="companyDetail.introduction.length > 200" @click="toggleExpand" 
            style="background: none; border: none; color: #55A5FA; cursor: pointer;">
      {{ isExpanded ? '收起' : '展开' }}
    </button>
          </div>
      </div>
      <div class="content_left_list">
        <h2 style="padding: 16px 0 0 16px;  height: 25px;
        font-weight: 700;
        font-size: 18px;
        color: #1D2129;
        line-height: 25px;
        text-align: left;">     
        策略列表</h2>
        <div class="content_left_menu" >
          <span style="margin-right: 140px;" @click="toggleSort('sign')">
    信号
    <img :src="getImageSrc('sign')">
  </span>
  <span v-for="item in sortOptions" :key="item.key" @click="toggleSort(item.key)">
      {{ item.label }}
      <img :src="getImageSrc(item.key)">
    </span>
        </div>
        <div class="content_left_main" 
             :style="dynamicStyle(item.total_profit_loss)" 
             v-for="item in sortedStrategyList" 
             :key="item.id">
          <img :src="item.picture" style="padding: 16px 8px 16px 16px;"  width="44px" height="44px" >
          <div class="flex_column" >
          <h2 style="padding: 16px 0 8px 0; font-size: 14px;  ">{{ item.name }}</h2>
            <p style="color: rgba(126, 127, 131, 1);font-size: 12px;">{{ item.platform_server}}</p>
          </div>
          <div style="display: flex;margin-left: 156px;" >
          <div class="price-container" :style="priceStyle(item.total_profit_loss)">
            <span class="price" :style="fontColor(item.total_profit_loss)">
              {{ item.total_profit_loss }}
            </span>
          </div>
          <div class="price-container" :style="priceStyle(item.total_profit_loss)">
            <span class="price" :style="fontColor(item.total_profit_loss)">
              {{ item.return_rate }}
            </span>
          </div>
          <div style="font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 400;
font-size: 12px;
color: #1D2129;
line-height: 17px;
text-align: center;
font-style: normal;
margin-top: 28px;
margin-left: 42px;
">
            <span style="margin-right: 82px;">{{ item.accuracy }}</span>
            <span>{{ item.max_drawdown }}</span>
          </div>
          
        </div>
          </div>
        
      </div>
    </div>
    <div class="content_right_wrapper">
      <div class="content_right">
        <h2 style="padding: 16px 0 0 16px; font-weight: 700;font-size: 18px; height: 25px;font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;">相关文章</h2>
        <div class="scrollable-articles">
          <!-- <div class="content_right_list" v-for="item in scoreList" :key="item.id"> -->
            <div class="content_right_list" >
            <h2 style="font-size: 14px;padding: 16px 0 0 16px;">{{ this.newtitle }}</h2>
            <p style="color: darkgrey;padding: 8px 16px 0 16px;font-size: 10px;">{{ this.newcontent }}</p>
            <p style="color: darkgrey;padding: 8px 16px 0 16px;font-size: 10px;">{{this. companyDetail.name}}发布于{{ this.time_since_created }}</p>
          </div>
        
        </div>
      </div>

      <div class="content_right" style="margin-top: 16px;">
        <h2 style="padding: 16px 0 0 16px; font-weight: 700;font-size: 18px; height: 25px;font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;">相关投诉</h2>
        <div class="scrollable-articles">
          <div class="content_right_list" v-for="item in complaintList" :key="item">
            <h2 style="font-size: 14px;padding: 16px 0 0 16px;">{{ item.company_name }}</h2>
            <p style="color: darkgrey;padding: 8px 16px 0 16px;font-size: 10px;" v-html="processedContent(item.content)"></p>
            <p style="color: darkgrey;padding: 8px 16px 0 16px;font-size: 10px;">{{item.user}}发布于{{formatDate(item.complaint_time)}}前</p>
          </div>
        </div>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import { getCompanyDetail } from '@/api/api'
import { getCompanyStrategyList,getComplaintList,getMemberNews } from '@/api/api'
import GSAPbutton from "@/utils/GSAPbutton.vue";
import { gsap } from "gsap";
export default {
    components: {GSAPbutton}, 
      data  () {
        return {
          enterAngle: 0, // 用来存储鼠标进入时的角度
          isExpanded: false, // 控制是否展开
          companyDetail:{
            name:'',
            introduction:'',
            avatar:'',
          },
          scoreList:'',
          newcontent:'',
          time_since_created:'',
          newtitle:'',
          complaintList:[],
          strategyList:[],
          id:this.$route.query.id,
          sortOptions: [
            { key: 'profit', label: '总盈亏' },
            { key: 'put', label: '收益率' },
            { key: 'per', label: '准确率' },
            { key: 'max', label: '最大回撤' }
          ], 
          sortStates: {
            sign: false,
            profit: false,
            put: false,
            per: false,
            max: false
          }
        }
      },
      computed: {
        companyDetail() {
      return {
        introduction: this. companyDetail.introduction // 这里替换为实际数据
      };
    },
    truncatedText() {
      return this.companyDetail.introduction.length > 200
        ? this.companyDetail.introduction.substring(0, 200) + "..."
        : this.companyDetail.introduction;
    },
        dynamicStyle() {
          return function(value) {
            const num = Number(value)
            return num > 0
              ? { 'background-color': 'rgba(249, 255, 250, 1)' }
              : { 'background': 'rgba(255, 249, 249, 1)' }
          }
        },
        priceStyle() {
          return function(value) {
            const num = Number(value)
            return num > 0
              ? { 'background-color': 'rgba(63, 209, 96, 0.26)' }
              : { 'background': 'rgba(209, 63, 63, 0.26)' }
          }
        },
        fontColor() {
          return function(value) {
            const num = Number(value)
            return num > 0
              ? { 'color': 'rgba(38, 206, 61, 1)' }
              : { 'color': 'rgba(206, 38, 38, 1)' }
          }
        },
        sortedStrategyList() {
          const list = [...this.strategyList]
          console.log('原始策略列表:', list); // 打印原始列表
          if (this.sortStates.sign || this.sortStates.sign === false) {
            return list.sort((a, b) => {
              const nameA = a.name.charAt(0).toLowerCase()
              const nameB = b.name.charAt(0).toLowerCase()
              return this.sortStates.sign ? nameB.localeCompare(nameA) : nameA.localeCompare(nameB)
            })
          } else if (this.sortStates.profit || this.sortStates.profit === false) {
            return list.sort((a, b) => {
              return this.sortStates.profit ? b.total_profit_loss - a.total_profit_loss : a.total_profit_loss - b.total_profit_loss
            })
          } else if (this.sortStates.put || this.sortStates.put === false) {
            return list.sort((a, b) => {
              const rateA = parseFloat(a.return_rate) || 0
              const rateB = parseFloat(b.return_rate) || 0
              return this.sortStates.put ? rateB - rateA : rateA - rateB
            })
          } else if (this.sortStates.per || this.sortStates.per === false) {
            return list.sort((a, b) => {
              const accuracyA = parseFloat(a.accuracy)
              const accuracyB = parseFloat(b.accuracy)
              console.log(this.sortStates.per);
              return this.sortStates.per ? accuracyB - accuracyA : accuracyA - accuracyB
            })
          } else if (this.sortStates.max || this.sortStates.max === false) {
            return list.sort((a, b) => {
              const maxDrawdownA = parseFloat(a.max_drawdown) || 0
              const maxDrawdownB = parseFloat(b.max_drawdown) || 0
              return this.sortStates.max ? maxDrawdownB - maxDrawdownA : maxDrawdownA - maxDrawdownB
            })
          }
          console.log('排序后的策略列表:', list); // 打印排序后的列表
          return list
        }
      },
      watch: {},
      methods: {
        toggleExpand() {
      const content = this.$refs.textContent;
      const container = this.$refs.textContainer;

      if (!this.isExpanded) {
        // 展开：先设置完整文本，再让高度自适应
        
        content.textContent = this.companyDetail.introduction;
        this.$nextTick(() => {
          const fullHeight = container.scrollHeight; // 获取展开后的高度
          gsap.fromTo(container, { height: "132px" }, { height: fullHeight, duration: 1, ease: "power2.out" });
        });
      } else {
        const fullHeight = container.scrollHeight;
    
        gsap.fromTo(container,{ height: fullHeight }, {
       height:"132px",
          duration: 1,
          ease: "power2.in",
          y: "0%",
          onComplete: () => {
              // 先收缩，再修改文本
              content.textContent = this.companyDetail.introduction.substring(0, 200) + "...";
            }
        });
        // gsap.from(container, {
        //   height:"132px",
        //   duration: 1,
        //   ease: "power2.in",
          
        
        // });
      }

      this.isExpanded = !this.isExpanded;
    },
                  // 处理 content 内容，去掉 <p> 标签并替换 <img> 标签为 (图片)
            processedContent(content) {
      // 去掉 <p> 标签
      let processedContent = content.replace(/<\/?p>/g, "");

      // 替换 <img> 标签为 (图片)
      processedContent = processedContent.replace(/<img[^>]*>/g, "（ 图片 ）");

      return processedContent;
    },
        handleMouseEnter(event) {
      const button = this.$refs.button;
      const rect = button.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标进入按钮时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      this.enterAngle = (angle + Math.PI) / (2 * Math.PI); // 将角度转化为 0-1 的值

      // 将角度转换为 360 度，并使用 GSAP 动画填充颜色
      const angleDeg = this.enterAngle * 360;

      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white,#55A5FA)`, // 根据鼠标角度动态填充背景
        duration: 1.2,
        color:"#55A5FA",
        ease: "power2.out",
        backgroundSize: "200% 200%", // 扩大背景区域
        scaleX: 1.1,
        scaleY: 1.1,
       
      });
     
    },
    handleMouseMove(event) {
 

 const button = this.$refs.button;
 const rect = button.getBoundingClientRect();
 const x = event.clientX - rect.left;
 const y = event.clientY - rect.top;
 const width = button.offsetWidth;
 const height = button.offsetHeight;

 // 计算鼠标在按钮内移动时的角度
 const angle = Math.atan2(y - height / 2, x - width / 2);
 const normalizedAngle = (angle + Math.PI) / (2 * Math.PI); // 转换为 0 到 1 之间的值
 const angleDeg = normalizedAngle * 360; // 将角度转换为 360 度

 // 使用 GSAP 动画平滑更新背景渐变的方向
 gsap.to(button, {
   background: `linear-gradient(${angleDeg}deg, white,#9BDCFF)`, // 根据鼠标的角度动态调整背景
   duration: 1.2, // 动画持续时间，快速响应
   ease: "power2.out",
 });
},

    handleMouseLeave() {
      const button = this.$refs.button;
      
      // 使用 GSAP 动画让颜色沿着原来的路径退出
      gsap.to(button, {
        background: `linear-gradient(${this.enterAngle * 360}deg,  #9BDCFF, #2F80ED)`, // 沿着进入时的角度退出
        backgroundSize: "100% 100%", // 恢复背景大小
        color:"white",
        duration: 1.2,
        ease: "power2.out",
        scaleX: 1,
        scaleY: 1,
      });
    }
  ,
        toggleSort(key) {
      this.sortStates = Object.keys(this.sortStates).reduce((acc, k) => {
        acc[k] = k === key ? !this.sortStates[k] : "";
       
        
        return acc;
      }, {});
    },
  gopartner(){
    this.$router.push({ path: '/contact' })
  },
    getImageSrc(key) {
      const sortState = this.sortStates[key];
      return require(`../../../assets/${sortState ? '排序-反排序.png' : '排序-正排序.png'}`);
    },
    async getComplaintListall() {
      try {
        const res = await getComplaintList()
        this.complaintList = res.results
      } catch (error) {
        console.error('获取投诉列表失败：', error)
      }
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const now = new Date()
      const diff = now - date // 时间差（毫秒）
      
      // 转换为相对时间
      const minutes = Math.floor(diff / (1000 * 60))
      const hours = Math.floor(minutes / 60)
      const days = Math.floor(hours / 24)
      
      if (days > 0) {
        return `${days}天`
      } else if (hours > 0) {
        return `${hours}小时`
      } else if (minutes > 0) {
        return `${minutes}分钟`
      } else {
        return '刚刚'
      }
    },
    async getMemberNews1() {
      try {
        const res = await getMemberNews(this.id)
        this.time_since_created = res.time_since_created
        this.newtitle = res.title
        this.newcontent = res.content
        console.log('公司新闻列表：',this.scoreList);
        
      } catch (error) {
        console.error('获取公司详情失败：', error)
      }
    }
      },
      created  () {
    
      },
      mounted  () {
         // 初始时，显示 200 字符的文本
    this.$nextTick(() => {
      if (this.companyDetail.introduction.length > 200) {
        this.$refs.textContent.textContent =
          this.companyDetail.introduction.substring(0, 200) + "...";
      }
    });
        this.getMemberNews1()
      this.getComplaintListall()
getCompanyDetail(this.id).then(response => {
  console.log('公司详情：',response);
  this.companyDetail.name = response.name
  this.companyDetail.introduction = response.introduction
  this.companyDetail.avatar = response.avatar
}).catch(error => {
  console.error(error);
});
getCompanyStrategyList(this.id).then(response => {
  console.log('公司策略列表：',response);
  this.strategyList = response
  
}).catch(error => {
  console.error(error);
});
      },
}
</script>

<style>
.app-container {
  background-color: rgba(248, 247, 251, 1);
  min-height: 100vh;
  display: flex; 
  flex-direction: column;
}
.content{
  display: flex;
  width: 100%;
     background-color: rgba(248, 247, 251, 1);
      margin: auto;
      margin-top: 16px;
      align-items: flex-start; 
     
}
.content_left{
  display: flex;
  flex-direction: column; /* 使li内的元素纵向排列 */
  width: 64%;
}
.content_left_list{
  background-color: #ffffff;
}
.content_left_top{
  margin-bottom: 10px;
      background-color: #ffffff;
      display: flex;
      height: 132px;
      border-radius: 8px 8px 8px 8px;
}
.center_top{
  display: flex;
  flex-direction: column; /* 使li内的元素纵向排列 */
}
.content_right_wrapper {
  width: 34%;
  margin-left: auto;
  display: flex;
  flex-direction: column;
}
.scrollable-articles {
  height: calc(100% - 60px); /* 减去标题高度 */
  overflow-y: auto;
  padding-right: 10px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
.content_right {
  width: 100%;
  background-color: #ffffff;
  border-radius: 4px 4px 4px 4px;
  height: calc((100vh - 132px) / 2); /* 平分高度 */
  overflow: hidden;
}
.content_left_menu {
 margin-top: 16px;

 display: flex;
  justify-content: flex-end;
  align-items: center; /* 垂直居中对齐 */
}
.content_left_menu span{
  padding-right: 72px;
  color: rgba(126, 127, 131, 1);
  font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 400;
font-size: 14px;
line-height: 20px;
cursor: pointer;
}
.content_left_menu img{
  width: 18px;
  height: 18px;
  margin-left: 4px;
  position: absolute;
  margin-top: 3px;
}
.content_left_main{
  display: flex;
  height: 77px;
 margin-top: 16px;
  background-color: rgba(249, 255, 250, 1);
}
.flex_column{
  display: flex;
  flex-direction: column;;
  
}
.price-container {
  width: 105px;
height: 25px;
background: rgba(63, 209, 96, 0.26);
border-radius: 116px 116px 116px 116px;
text-align: center;
margin-left: 16px;
margin-top: 24px;
}
.price{
  width: 73px;
height: 17px;
font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
font-weight: 400;
font-size: 12px;
color: rgba(38, 206, 61, 1);
line-height: 17px;
}
.content_right_list{
  height: 112px;
  
  
}
.gsap-button {
  width: 120px;
  height: 36px;
  background: linear-gradient( 135deg, #9BDCFF 0%, #2F80ED 100%); 
  border-radius: 2px;
  border: 2px solid transparent; 
  margin-left: 220px;
  color: white; 
  border: none;
  cursor: pointer; 
  
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.gsap-button:focus {
  outline: none;
}
</style>